/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="67.93"
        height="95.58"
        viewBox="0 0 67.93 95.58"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="#0e497b"
          d="M57.11 10.42a10.85 10.85 0 0 1 10.82 10.54v63.8a10.86 10.86 0 0 1-10.54 10.82H10.83A10.86 10.86 0 0 1 0 84.76a1.25 1.25 0 1 1 2.5 0 8.36 8.36 0 0 0 8.07 8.32h46.54a8.35 8.35 0 0 0 8.32-8.07V21.24a8.36 8.36 0 0 0-8.07-8.32h-8a1.252 1.252 0 0 1-.13-2.5h7.83Z"
          className="icon-fill icon-base"/>
        <path
          fill="#0e497b"
          d="M18.5 10.42a1.25 1.25 0 0 1 .13 2.49h-7.8a8.36 8.36 0 0 0-8.33 8.08v63.77a1.25 1.25 0 0 1-2.49.12V21.24A10.85 10.85 0 0 1 10.5 10.42h8Z"
          className="icon-fill icon-base"/>
        <path
          fill="#0e497b"
          d="M34.06 0a6.42 6.42 0 0 0-5.79 3.65 5.42 5.42 0 0 1-2.6 2.85 16.21 16.21 0 0 1-4.68 1.55c-.52.1-1 .16-1.41.21H18.5a1.24 1.24 0 0 0-1.22 1.25v6a1.25 1.25 0 0 0 1.22 1.27h30.91a1.25 1.25 0 0 0 1.25-1.28v-6a1.25 1.25 0 0 0-1.1-1.24h-.15a14.76 14.76 0 0 1-2.33-.28A16.24 16.24 0 0 1 42.5 6.5a5.52 5.52 0 0 1-2.53-2.57l-.13-.26A6.44 6.44 0 0 0 34.06 0Zm0 2.5a4 4 0 0 1 3.54 2.25 8.13 8.13 0 0 0 3.75 4 19.09 19.09 0 0 0 5.27 1.75l.33.06c.33.06.64.1.94.14h.27v3.55H19.77v-3.51c.48 0 1-.12 1.62-.23a18.89 18.89 0 0 0 5.39-1.79 7.83 7.83 0 0 0 3.7-4 3.93 3.93 0 0 1 3.58-2.22Z"
          className="icon-fill icon-base"/>
        <path
          fill="#ffb81c"
          d="M32.71 22.7V25l-.36.07-.36.07a5.5 5.5 0 0 0-4.15 3.36 6.87 6.87 0 0 0-.48 3.14 5.38 5.38 0 0 0 2.89 4.59 22.68 22.68 0 0 0 2.41 1.08c1 .43 2 .82 3 1.24a1.85 1.85 0 0 1 1.15 2 2 2 0 0 1-1.62 2 5.42 5.42 0 0 1-1.27.13 3.17 3.17 0 0 1-3.25-2.36c-.09-.29-.16-.58-.24-.89l-3.86 1a8 8 0 0 0 1.93 3.85 6.46 6.46 0 0 0 4.22 2v3h2.48v-3.02c.5-.1 1-.18 1.47-.3a5.75 5.75 0 0 0 4-3.29 6.71 6.71 0 0 0 .47-4 5.29 5.29 0 0 0-2.64-3.85 30.28 30.28 0 0 0-3.69-1.61c-.75-.3-1.49-.65-2.22-1a1.63 1.63 0 0 1-.83-1 2.25 2.25 0 0 1 1.58-2.83 2.61 2.61 0 0 1 2.58.67 4.81 4.81 0 0 1 1 1.59 6.31 6.31 0 0 1 .25.58l3.46-1.43a7.16 7.16 0 0 0-1.27-2.6A6.11 6.11 0 0 0 35.2 25v-2.3Z"
          className="icon-fill icon-accent"
          fillRule="evenodd"/>
        <path
          fill="#0e497b"
          d="M56.33 55.42a1.25 1.25 0 0 1 .13 2.49H20.5a1.252 1.252 0 0 1-.13-2.5h36ZM56.33 63.88a1.25 1.25 0 0 1 .13 2.49H12.17a1.24 1.24 0 0 1-1.25-1.25 1.26 1.26 0 0 1 1.12-1.25h44.29ZM56.05 72.32a1.25 1.25 0 0 1 .13 2.49h-44.3a1.25 1.25 0 0 1-.13-2.49h44.3ZM56.05 80.75a1.25 1.25 0 0 1 .13 2.49h-44.3a1.25 1.25 0 0 1-.13-2.49h44.3Z"
          className="icon-fill icon-base"/>
      </svg>

    );
  }
}

Icon.displayName = 'ClipboardWithDollarSignPaperIcon';

export default Icon;
